import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/styles'
import {
    colors,
    ListItem,
    ListItemText,
    Paper,
    Input,
    InputAdornment,
    IconButton
} from '@material-ui/core'
import apiConfig from 'apiConfig'
import axios from 'utils/axios'
import {Link, Redirect, useHistory, useParams} from 'react-router-dom'
import { useSearchDelay } from 'utils/useSearchDelay'
import { SearchOutlined } from "@material-ui/icons";
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import { useSelector } from "react-redux";
import { Dialog , DialogContent} from "@material-ui/core";
import qs from "query-string";
import { getHideArchivedPreference } from "utils/archivedPreference";

const useStyles = makeStyles(theme => ({
    searchPaper: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        paddingRight: 0,
        display: 'flex',
        alignItems: 'center',
        width: '400px',
        [theme.breakpoints.down('xs')]: {
          width: '300px'
        }
      },
      input: {
        width: '100%'
      },
      muiDialogPaper: {
        '& div.MuiDialog-scrollPaper': {
            alignItems: 'baseline',
            paddingTop: '55px',
            [theme.breakpoints.down('xs')]: {
              paddingTop: '70px'
            }
        },
        '& div.MuiDialog-paper': {
          margin: 0
        },
        '& div.MuiDialogContent-root':{
          padding: 0,
        },
        '& .MuiOutlinedInput-input':{
          padding: '12px 1px',
          color: '#000000'
        },
        '& div.MuiDialogContent-root:first-child':{
          paddingTop: 0
        },
        '& div.MuiOutlinedInput-adornedEnd':{
          paddingRight: 0
        },
        '& div.MuiInputAdornment-positionEnd':{
          marginLeft: 0
        }
      },
      searchIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary
      },
      clearIcon: {
        marginRight: theme.spacing(1)
      }
}))

const SearchModal = ({ open, onClose}) => {;
    const history = useHistory();
    const classes = useStyles();
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = () => {
        // /customers/search (not plain /search) so the sidebar highlights Customers > Manage,
        // consistent with every other entry point into customer search.
        history.push({ pathname: "/customers/search", search: qs.stringify({ query: searchTerm , archived: getHideArchivedPreference() ,isAddressSearch : false , searchField : 0,type : 'customer' }) });
        onClose();
    }
    useEffect(() => {
        setSearchTerm('');
    }, [open])
    return (
        <Dialog open={open} onClose={onClose} className={classes.muiDialogPaper}>
            <DialogContent>
                <Paper className={classes.searchPaper}>
                    <SearchIcon className={classes.searchIcon} />
                    <Input
                    className={classes.input}
                    disableUnderline
                    placeholder='Search'
                    fullWidth
                    value={searchTerm}
                    autoFocus
                    onChange={event => {
                        setSearchTerm(event.target.value);
                    }}
                    onKeyUp={(ev) => {
                        if (ev.key === 'Enter' && searchTerm!=='') {
                            handleSearch();
                        }
                    }}
                    endAdornment={searchTerm && (
                        <InputAdornment position="end">
                        <IconButton onClick={()=> { setSearchTerm('')}} style={{padding : '4px'}}>
                            <ClearIcon />
                        </IconButton>
                        </InputAdornment>
                    )
                    }
                    />
                </Paper>
                </DialogContent>
            </Dialog>
        )
}

SearchModal.propTypes = {
    defaultType: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    handleSelectedSource: PropTypes.func
}

export default SearchModal
